module.exports = __webpack_public_path__ + "img/console32.fba7332f.jpg";